import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import LieuAppointment from "./appointment/LieuAppointment";
import Typography from "@material-ui/core/Typography";
import {
  addFieldData,
  handleContinueFooter,
  setItemBreadcrumbs,
  setMessageWithCode,
  setReturnedValue,
  showFooterContinue,
  setClosePanel
} from "../actions";
import {
  List as MaterialList,
  ListItem,
  ListItemText
} from "@material-ui/core";
import PriorityCode from "./PriorityCode";
import { getProtocol } from "../utils/protocole";
import VideocamIcon from "@material-ui/icons/Videocam";
import AlertDialog from "./AlertDialog";
import { translator } from "../utils/i18n";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";

import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import { Navigation, Pagination } from "swiper";

import "swiper/modules/pagination/pagination.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "./swiperCustom.css";
import "swiper/swiper-bundle.css";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItem: undefined,
      target: undefined,
      showBtnContinue: props.step.needContinue,
      nbrSlide: 1,
      divView: 1,
      widthMobile: "",
      mobile: ""
    };
    if (props.step.needContinue) {
      this.props.showFooterContinue(true);
    }
  }

  swiperRef = React.createRef();

  componentDidMount() {
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);
    if (this.props.step.needContinue) {
      this.props.showFooterContinue({
        isShow: true,
        handler: this.handleSubmit,
        disabled: !this.state.selectedItem
      });
      this.props.handleContinueFooter(this.handleSubmit);
    }

    const div = document.querySelector(".wrap-content-step");
    const resizeObserver = new ResizeObserver(this.handleDivSizeChange);
    resizeObserver.observe(div);
    setTimeout(function() {
      resizeObserver.unobserve(div);
    }, 1000);

    if (this.props.activeStep.subStep === 5) {
      this.props.closeNew(true);
    }
  }

  componentWillUnmount() {
    const dataKey = this.props.step.data.keyValue;
    this.props.resetData(dataKey);
    if (this.props.step.needContinue) {
      this.props.showFooterContinue({
        isShow: false,
        handler: undefined,
        disabled: undefined
      });
      this.props.handleContinueFooter(null);
      this.setState({ showBtnContinue: false });
    }
  }

  handlePrevious = () => {
    if (
      this.swiperRef &&
      this.swiperRef.current &&
      this.swiperRef.current.swiper
    ) {
      this.swiperRef.current.swiper.slidePrev();
    }
  };

  handleNext = () => {
    if (
      this.swiperRef &&
      this.swiperRef.current &&
      this.swiperRef.current.swiper
    ) {
      this.swiperRef.current.swiper.slideNext();
    }
  };

  getData = () => {
    const dataKey = this.props.step.data.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      let data = this.props.dataSource[dataKey];
      if (data && this.props.step.data.formatSource) {
        data = this.props.step.data.formatSource(data);
      }
      if (data.length === 1 && !this.state.selectedItem) {
        this.setState({ selectedItem: data[0] });
      }
      return data;
    }
    return null;
  };

  getDataNew = () => {
    const dataKey = this.props.step.data.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      let data = this.props.dataSource[dataKey];

      if (data.length === 1 && !this.state.selectedItem) {
        this.setState({ selectedItem: data[0] });
      }
      return data;
    }
    return null;
  };

  getRenderSelect = data => {
    if (data) {
      return data.map(item => {
        return (
          <MenuItem
            key={item.key}
            value={item.value}
            datavalue={item.dataValue}
            datalabel={item.label}
          >
            {item.label}
          </MenuItem>
        );
      });
    }
    return [];
  };

  getRenderItem = (data, lieu = "") => {
    const { selectedItem } = this.state;

    if (data) {
      if (lieu === "appointmentLocation") {
        return data.map(item => {
          const obj2 = {
            value: item.id,
            key: "item-" + item.id,
            label: item.libelle,
            dataValue: 0
          };
          const itemNew = { ...item, ...obj2 };
          const isDateEmpty = itemNew.fistdispo?.date_aff == "";
          const opacity = isDateEmpty ? 0.5 : 1;
          return (
            <ListItem
              button
              key={itemNew.key}
              datalabel={itemNew.label}
              datavalue={itemNew.value}
              onClick={e => {
                if (!isDateEmpty) {
                  this.handleClickNew(e, itemNew);
                }
              }}
              selected={selectedItem ? selectedItem.key === itemNew.key : false}
              className={
                selectedItem && data.length == 1 ? "noBackSelection" : ""
              }
            >
              <ListItemText
                primary={itemNew.label}
                secondary={
                  <React.Fragment>
                    <Typography component="span" variant="body2">
                      {isDateEmpty ? (
                        <strong style={{ opacity: opacity }}>
                          Aucune Dispo
                        </strong>
                      ) : (
                        <>
                          Prochaine dispo:{" "}
                          <strong>{itemNew.fistdispo?.date_aff}</strong>
                        </>
                      )}
                    </Typography>
                  </React.Fragment>
                }
                style={{
                  cursor: isDateEmpty ? "not-allowed" : "pointer",
                  opacity: opacity
                }}
              />
            </ListItem>
          );
        });
      } else {
        return data.map(item => {
          return (
            <ListItem
              button
              key={item.key}
              datalabel={item.label}
              datavalue={item.value}
              onClick={e => {
                this.handleClick(e, item);
              }}
              selected={selectedItem ? selectedItem.key === item.key : false}
              className={
                selectedItem && data.length == 1 ? "noBackSelection" : ""
              }
            >
              <ListItemText className="text" primary={item.label} />
            </ListItem>
          );
        });
      }
    }
    return [];
  };

  handleDivSizeChange = () => {
    const wrapContentStep = document.querySelector(".wrap-content-step");

    if (wrapContentStep) {
      let space = wrapContentStep.offsetWidth;

      if (space > 800) {
        this.setState({ nbrSlide: 3 });
      } else if (space < 800 && space > 500) {
        this.setState({ nbrSlide: 2 });
        this.setState({ divView: 2 });
      } else {
        this.setState({ nbrSlide: 1 });
        this.setState({ widthMobile: true });
        this.setState({ mobile: true });
      }
    }
  };

  getRenderItemPraticien = data => {
    const { selectedItem } = this.state;
    if (data) {
      return data.map(item => {
        if (item.value === 0) {
          return (
            <div key={item.key}>
              <ListItem
                button
                datalabel={item.label}
                datavalue={item.value}
                onClick={e => this.handleClick(e, item)}
                selected={selectedItem ? selectedItem.key === item.key : false}
                className={
                  selectedItem && data.length === 1 ? "noBackSelection" : ""
                }
              >
                <img
                  src="images/calendar-bolt.svg"
                  style={{ marginRight: "5px" }}
                />
                <ListItemText
                  primary={
                    <span style={{ fontWeight: 500 }}>{item.label}</span>
                  }
                />
              </ListItem>
              <ListItem style={{ fontSize: "small", color: "grey" }}>
                Ou sélectionnez un praticien :
              </ListItem>
            </div>
          );
        } else {
          return (
            <ListItem
              button
              key={item.key}
              datalabel={item.label}
              datavalue={item.value}
              onClick={e => this.handleClick(e, item)}
              selected={selectedItem ? selectedItem.key === item.key : false}
              className={
                selectedItem && data.length === 1 ? "noBackSelection" : ""
              }
            >
              <ListItemText
                primary={<span style={{ fontWeight: 500 }}>{item.label}</span>}
              />
            </ListItem>
          );
        }
      });
    }
    return [];
  };

  getRenderItemNew = data => {
    const { selectedItem } = this.state;

    if (data) {
      const butn = document.querySelector(".button-panel");

      if (this.handleDivSizeChange) {
        butn?.addEventListener("click", () => {
          const div = document.querySelector(".wrap-content-step");
          const resizeObserver = new ResizeObserver(this.handleDivSizeChange);
          resizeObserver.observe(div);
          setTimeout(function() {
            resizeObserver.unobserve(div);
          }, 1000);
        });
      }

      if (data.length <= 2) {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyItems: "center",
              gap: "10%",
              justifyContent: "center"
            }}
          >
            {data.map(item => {
              const obj2 = {
                value: item.id,
                key: "item-" + item.id,
                label: item.libelle,
                dataValue: 0
              };
              const itemNew = { ...item, ...obj2 };
              return (
                <LieuAppointment
                  button
                  key={item.id}
                  item={itemNew}
                  datalabel={item.label}
                  datavalue={item.value}
                  selected={
                    selectedItem ? selectedItem.key === item.key : false
                  }
                  className={
                    selectedItem && data.length == 1 ? "noBackSelection" : ""
                  }
                  onClick={e => this.handleClickNew(e, itemNew)}
                />
              );
            })}
          </div>
        );
      } else {
        return (
          <>
            <Swiper
              ref={this.swiperRef}
              className="swipperCustom"
              modules={[Navigation, Pagination]}
              spaceBetween={200}
              slidesPerView={this.state.divView === 2 ? 2 : this.state.nbrSlide}
              // navigation
              pagination={{ clickable: true }}
              centeredSlides={true}
              centerInsufficientSlides={true}
              centeredSlidesBounds={true}
              style={{ paddingBottom: "40px" }}
              navigation={{
                prevEl: ".swiper-button-prev2",
                nextEl: ".swiper-button-next2"
              }}
            >
              {data.map(item => {
                const obj2 = {
                  value: item.id,
                  key: "item-" + item.id,
                  label: item.libelle,
                  dataValue: 0
                };
                const itemNew = { ...item, ...obj2 };
                return (
                  <SwiperSlide key={item.id}>
                    <LieuAppointment
                      button
                      key={item.id}
                      item={itemNew}
                      datalabel={item.label}
                      datavalue={item.value}
                      selected={
                        selectedItem ? selectedItem.key === item.key : false
                      }
                      className={
                        selectedItem && data.length == 1
                          ? "noBackSelection"
                          : ""
                      }
                      onClick={e => this.handleClickNew(e, itemNew)}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </>
        );
      }
    }
    return [];
  };

  getRenderItemNewMobile = data => {
    const { selectedItem } = this.state;

    alert(this.state.widthMobile);

    if (data) {
      const butn = document.querySelector(".button-panel");

      if (this.handleDivSizeChange) {
        butn.addEventListener("click", () => {
          const div = document.querySelector(".wrap-content-step");
          const resizeObserver = new ResizeObserver(this.handleDivSizeChange);
          resizeObserver.observe(div);
          setTimeout(function() {
            resizeObserver.unobserve(div);
          }, 1000);
        });
      }

      if (data.length < 2) {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyItems: "center",
              gap: "10%",
              justifyContent: "center"
            }}
          >
            {data.map(item => {
              const obj2 = {
                value: item.id,
                key: "item-" + item.id,
                label: item.libelle,
                dataValue: 0
              };
              const itemNew = { ...item, ...obj2 };
              return (
                <LieuAppointment
                  button
                  key={item.id}
                  item={itemNew}
                  datalabel={item.label}
                  datavalue={item.value}
                  selected={
                    selectedItem ? selectedItem.key === item.key : false
                  }
                  className={
                    selectedItem && data.length == 1 ? "noBackSelection" : ""
                  }
                  onClick={e => this.handleClickNew(e, itemNew)}
                />
              );
            })}
          </div>
        );
      } else {
        return (
          <>
            <Swiper
              ref={this.swiperRef}
              className="swipperCustom"
              modules={[Navigation, Pagination]}
              spaceBetween={200}
              slidesPerView={1}
              pagination={{ clickable: true }}
              centeredSlides={true}
              centerInsufficientSlides={true}
              centeredSlidesBounds={true}
              style={{ paddingBottom: "40px" }}
              navigation={{
                prevEl: ".swiper-button-prev2",
                nextEl: ".swiper-button-next2"
              }}
            >
              {data.map(item => {
                const obj2 = {
                  value: item.id,
                  key: "item-" + item.id,
                  label: item.libelle,
                  dataValue: 0
                };
                const itemNew = { ...item, ...obj2 };
                return (
                  <SwiperSlide key={item.id}>
                    <LieuAppointment
                      button
                      key={item.id}
                      item={itemNew}
                      datalabel={item.label}
                      datavalue={item.value}
                      selected={
                        selectedItem ? selectedItem.key === item.key : false
                      }
                      className={
                        selectedItem && data.length == 1
                          ? "noBackSelection"
                          : ""
                      }
                      onClick={e => this.handleClickNew(e, itemNew)}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </>
        );
      }
    }
    return [];
  };

  async handleClick(event, item) {
    if (this.props.step.needContinue) {
      this.setState({ selectedItem: item, target: event.target });
    } else {
      const label = item.label;
      const value = event.target.value;
      const dataValue = item.value;
      const seq = item.sequence2;
      this.validateDataSelected(label, value, dataValue, seq);
    }
  }
  async handleClickNew(event, item) {
    const label = item.label;
    const value = event.target.value;
    const dataValue = item.value;
    const seq = item.sequence2;
    this.validateDataSelected(label, value, dataValue, seq);
    this.handleSubmit;
  }

  validateDataSelected(label, value, dataValue, sequence2 = "") {
    const returnedKey = this.props.step.returned.key;
    const returnedDataKey = this.props.step.returned.dataKey
      ? this.props.step.returned.dataKey
      : returnedKey;
    this.buildBreadcrumbs(label);
    if (returnedKey && value !== "") {
      if (sequence2) {
        this.props.getProtocol(sequence2, this.props.activeStep);
      } else {
        this.props.isValid(true);
      }
      this.props.setReturnedValue({
        [returnedKey]: value,
        [returnedDataKey]: dataValue
      });
    } else {
      this.props.isValid(false);
    }
  }

  buildBreadcrumbs = value => {
    const element = { textItem: value, stepItem: { ...this.props.activeStep } };
    this.props.setBreadcrumbs(element);
  };

  handleSubmit = () => {
    const { selectedItem, target } = this.state;
    const label = selectedItem.label;
    const value = target ? target.value : undefined;
    const dataValue = selectedItem.value;
    const seq = selectedItem.sequence2;
    this.validateDataSelected(label, value, dataValue, seq);
  };

  handleErrorClose = () => {
    this.props.setMessageWithCodeFunc("");
  };

  render() {
    const { step } = this.props;
    let data = this.getData();
    let dataNew = this.getDataNew();
    const { widthMobile, mobile } = this.state;

    if (step.returned.key == "appointmentLocation") {
      this.props.showFooterContinue({
        isShow: false,
        handler: this.handleSubmit,
        disabled: !this.state.selectedItem
      });
    } else {
      this.props.showFooterContinue({
        isShow: this.state.showBtnContinue,
        handler: this.handleSubmit,
        disabled: !this.state.selectedItem
      });
    }

    return (
      <React.Fragment>
        {data && (
          <div className="multiple-select-custom">
            {this.props.typeConsultation === "teleconsult" ? (
              <>
                {step.returned.key !== "appointmentLocation" ? (
                  <>
                    <label className="label">
                      {step.icon && <img src={step.icon} alt={step.label} />}
                      &nbsp;
                      {step.label}
                      {this.props.typeConsultation === "teleconsult" && (
                        <VideocamIcon className="icon-video" />
                      )}
                    </label>
                    <MaterialList>{this.getRenderItem(data)}</MaterialList>
                  </>
                ) : (
                  <>
                    <label className="label">
                      {translator()._("W_MESSAGE_TELECONSULT")}
                    </label>
                  </>
                )}
              </>
            ) : (
              this.props.typeConsultation !== "teleconsult" && (
                <>
                  <label className="label">
                    {step.icon && <img src={step.icon} alt={step.label} />}
                    &nbsp;
                    {step.label}
                  </label>
                  {this.props.activeStep.subStep === 5 ? (
                    widthMobile ? (
                      <MaterialList>
                        {this.getRenderItemPraticien(data)}
                      </MaterialList>
                    ) : mobile ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <div style={{ width: "15%" }}>
                          <button
                            className="swiper-button-prev2 swiper-button-prev"
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "10%",
                              transform: "translateY(-50%)"
                            }}
                            onClick={this.handlePrevious}
                          >
                            {/* Previous */}
                          </button>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "20px",
                            width: "60%",
                            overflowX: "scroll",
                            justifyContent: "space-evenly",
                            flex: "auto"
                          }}
                        >
                          {this.getRenderItemNew(dataNew)}
                        </div>
                        <div style={{ width: "15%" }}>
                          <button
                            className="swiper-button-next2 swiper-button-next"
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "10%",
                              transform: "translateY(-50%)"
                            }}
                            onClick={this.handleNext}
                          >
                            {/* Next */}
                          </button>
                        </div>
                      </div>
                    ) : step.returned.key === "appointmentLocation" ? (
                      <MaterialList>
                        {this.getRenderItem(dataNew, step.returned.key)}
                      </MaterialList>
                    ) : (
                      <>
                        <MaterialList>
                          {this.getRenderItemPraticien(data)}
                        </MaterialList>
                      </>
                    )
                  ) : (
                    <MaterialList>{this.getRenderItem(data)}</MaterialList>
                  )}
                </>
              )
            )}
            {step.showLinkPriorityCode &&
              this.props.isShowLinkPriorityCode &&
              this.props.isFromAdmin !== "admin" && <PriorityCode />}
          </div>
        )}
        {this.props.messageWithCode && this.props.messageWithCode.text && (
          <AlertDialog
            content={this.props.messageWithCode.text}
            onClick={this.handleErrorClose}
          />
        )}
      </React.Fragment>
    );
  }
}

List.propTypes = {
  activeStep: PropTypes.any,
  dataSource: PropTypes.any,
  fetchData: PropTypes.func,
  getProtocol: PropTypes.func,
  handleContinueFooter: PropTypes.func,
  isFromAdmin: PropTypes.string,
  isShowLinkPriorityCode: PropTypes.any,
  isValid: PropTypes.func,
  resetData: PropTypes.func,
  setBreadcrumbs: PropTypes.func,
  setReturnedValue: PropTypes.func,
  showFooterContinue: PropTypes.func,
  setClosePanel: PropTypes.func,
  closeNew: PropTypes.func,
  messageWithCode: PropTypes.shape({
    text: PropTypes.string,
    code: PropTypes.number
  }),
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      formatSource: PropTypes.func,
      keyValue: PropTypes.any
    }),
    icon: PropTypes.any,
    label: PropTypes.any,
    needContinue: PropTypes.any,
    returned: PropTypes.shape({
      dataKey: PropTypes.any,
      key: PropTypes.any
    }),
    showLinkPriorityCode: PropTypes.any
  }),
  typeConsultation: PropTypes.string,
  setMessageWithCodeFunc: PropTypes.func
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    activeStep: state.activeStep,
    isShowLinkPriorityCode: state.configuration.baffcodeprioritaire,
    typeConsultation: state.returnedValue.typeConsultation,
    isFromAdmin: state.returnedValue.from,
    messageWithCode: state.messageWithCode
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: functionName => dispatch(functionName()),
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    setBreadcrumbs: item => dispatch(setItemBreadcrumbs(item)),
    resetData: key => dispatch(addFieldData(key, null)),
    getProtocol: (url, activeStep) => dispatch(getProtocol(url, activeStep)),
    showFooterContinue: isShow => dispatch(showFooterContinue(isShow)),
    handleContinueFooter: handler => dispatch(handleContinueFooter(handler)),
    setMessageWithCodeFunc: message => dispatch(setMessageWithCode(message)),
    setClosePanel: value => dispatch(setClosePanel(value)),
    closeNew: state => dispatch(addFieldData("closeN", state))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List);
